import { BlackjackGameLogic, GameState, RoundType } from 'game-logic';
import { GameRound } from '../../common/phaser/model/game-round';
import { RoundParams } from '../../common/phaser/model/round-params';
import { RoundResultSubmitter } from '../../common/phaser/model/round-result-submitter';

export type OnGameStateChangedAction = (state: GameState) => void;

export class BlackjackGameRound implements GameRound {
  public get roundType(): RoundType {
    return RoundType.Standard;
  }
  public get currentGame(): BlackjackGameLogic {
    return this.gameLogic;
  }
  public get gameLogicActions() {
    return this.gameLogic.logicActionBus;
  }
  public get logicEventQueue() {
    return this.gameLogic.logicEventQueue;
  }
  public set onGameStateChangedAction(value: OnGameStateChangedAction) {
    this.gameStateChangedAction = value;
  }

  public readonly roundResultsSubmitter: RoundResultSubmitter;

  private gameLogic: BlackjackGameLogic;
  private gameState: GameState;
  private sideEffectsSubmitted: boolean;
  private gameStateChangedAction?: OnGameStateChangedAction;

  constructor(gameLogic: BlackjackGameLogic, roundParams: RoundParams) {
    this.gameLogic = gameLogic;
    this.gameState = GameState.Init;
    this.sideEffectsSubmitted = false;

    this.roundResultsSubmitter = roundParams.roundResultSubmitter;

    this.gameLogic.logicActionBus.on('onGameCompleted', () => {
      this.setGameState(GameState.Finished);
      this.submitSideEffectsIfNeeded(true);
    });
    this.gameLogic.logicActionBus.on('onGameLost', () => {
      this.setGameState(GameState.Finished);
      this.submitSideEffectsIfNeeded(false);
    });
  }

  async submitSideEffectsIfNeeded(isComplete: boolean): Promise<void> {
    if (this.sideEffectsSubmitted) {
      return;
    }

    await this.roundResultsSubmitter.submitResult(this.gameLogic, isComplete);

    this.sideEffectsSubmitted = true;
  }

  public isFinished(): boolean {
    return this.sideEffectsSubmitted;
  }

  public onGameSetupAnimationFinished() {
    this.setGameState(GameState.InProgress);
  }

  private setGameState(gameState: GameState) {
    this.gameState = gameState;
    this.gameStateChangedAction?.(gameState);
  }
}
